import { useIsFetching } from '@tanstack/react-query';
import { rSimProductsQueries } from 'rSimInventory/utils/rsimProductsQueries.ts';

export const useIsFetchingQueryTable = () => {
  return (
    useIsFetching({
      queryKey: rSimProductsQueries.list(),
    }) > 0
  );
};
